import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { MdPhotoLibrary } from "react-icons/md";
import { formatDate, CDN_URL } from "../Helpers";

export default function OnePost(props) {

  const appContext = useContext(AppContext);

  const post = props.post || {};

  const [photos, setPhotos] = useState([]);

  function buildPhotos() {
    const arr = [];

    if (post.photo1 && String(post.photo1).trim().length > 0) arr.push(post.photo1);
    if (post.photo2 && String(post.photo2).trim().length > 0) arr.push(post.photo2);
    if (post.photo3 && String(post.photo3).trim().length > 0) arr.push(post.photo3);

    setPhotos(arr);
  }

  useEffect(() => {
    buildPhotos();
  }, [post?.uuid])

  function getPhotoUrl(src) {
    if (!src) return "";
    if (String(src).startsWith("http")) return src;
    return `${CDN_URL}${src}`;
  }

  function renderCaptionOverlay() {
    const hasCaption = (post.description && String(post.description).trim().length > 0);

    return (
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          padding: "14px",
          paddingTop: "40px",
          color: "#fff",
          background: "linear-gradient(to top, rgba(0,0,0,0.78), rgba(0,0,0,0.30), rgba(0,0,0,0))",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "14px",
              background: "rgba(255,255,255,0.16)",
              border: "1px solid rgba(255,255,255,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <MdPhotoLibrary size={18} />
          </div>

          <div style={{ flexGrow: 1 }}>
            <h6 className="mNoMargin font-semi-bold" style={{ fontSize: "14px", color: "#fff" }}>
              Community Post
            </h6>
            <p className="mNoMargin font-regular" style={{ fontSize: "12px", opacity: 0.85 }}>
              {post.dateCreated ? String(formatDate(post.dateCreated)) : ""}
            </p>
          </div>
        </div>

        {
          hasCaption ?
            <div style={{ marginTop: "10px" }}>
              <pre
                className="font-regular"
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  opacity: 0.95,
                  color: "#fff",
                }}
              >
                {post.description}
              </pre>
            </div>
            : ""
        }
      </div>
    )
  }

  function renderFrame(children) {
    return (
      <div
        className="mShadow2"
        style={{
          width: "100%",
          borderRadius: "22px",
          overflow: "hidden",
          position: "relative",
          background: "var(--surfaceColor)",
          border: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        {children}
      </div>
    )
  }

  function renderSingleImage() {
    return renderFrame(
      <>
        <div
          style={{
            width: "100%",
            height: "420px",
            backgroundImage: `url(${getPhotoUrl(photos[0])})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        />
        {renderCaptionOverlay()}
      </>
    )
  }

  function renderGrid() {
    return renderFrame(
      <>
        <div className="row mNoMargin" style={{ width: "100%" }}>

          <div className="col-8 mNoPadding" style={{ height: "420px" }}>
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${getPhotoUrl(photos[0])})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            />
          </div>

          <div className="col-4 mNoPadding" style={{ height: "420px" }}>
            <div style={{ width: "100%", height: "50%", borderLeft: "2px solid rgba(255,255,255,0.8)" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${getPhotoUrl(photos[1])})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              />
            </div>

            <div
              style={{
                width: "100%",
                height: "50%",
                borderLeft: "2px solid rgba(255,255,255,0.8)",
                borderTop: "2px solid rgba(255,255,255,0.8)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${getPhotoUrl(photos[2] || photos[1])})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              />
            </div>
          </div>

        </div>

        {renderCaptionOverlay()}
      </>
    )
  }

  if (!photos || photos.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: "16px" }}>
      {
        (photos.length === 1)
          ? renderSingleImage()
          : renderGrid()
      }
    </div>
  )
}
